<div class="modal-header heading">
    <span>Call Flow Details</span>
    <span *ngIf="tripId">: {{ tripId }}</span>
</div>
<div
    class="overflow-y-auto margin-top-20"
    [ngClass]="callFlowDetails.description === null && callFlowDetails.files.length === 0 ? 'no-record' : ''"
>
    <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card card-layout callFlow-details-card">
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <h5><b>Notes:</b></h5>
                </div>
            </div>
            <div class="col-lg-12 col-md-12">
                <textarea
                    class="form-control call-flow-notes"
                    readonly
                    [style.color]="callFlowDetails.description === null ? '#A94442' : 'black'"
                >
                    {{ callFlowDetails.description === null ? 'No Record Found!' : callFlowDetails.description }}
                </textarea>
            </div>
        </div>
    </div>
    <div class="col-lg-8 col-md-12 col-sm-12">
        <div class="card card-layout callFlow-details-card">
            <div class="col-lg-12 col-md-12 mb-4">
                <div class="file-button d-flex justify-content-between">
                    <h5><b>File:</b></h5>
                </div>
            </div>
            <div *ngIf="callFlowDetails.files.length === 0 && loader === false" class="ml-4">
                <span class="text-danger">No Record Found!</span>
            </div>
            <div *ngIf="loader === true" class="ml-4">
                <div class="d-flex justify-content-center">
                    <div class="dot-pulse mt-5"></div>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 d-flex justify-content-center align-items-start overflow-auto">
                <table *ngIf="callFlowDetails.files.length > 0" id="jobid" class="table card-layout table-striped table mt-0">
                    <thead>
                        <tr>
                            <td class="header_td table_heading">
                                <div class="header_container text-primary">
                                    <div class="header_title cursorPointer col-md-4">File Name</div>
                                    <div class="header_title cursorPointer col-md-3">File Type</div>
                                    <div class="header_title cursorPointer col-md-4">Created On</div>
                                    <div class="header_title cursorPointer col-md-1">Action</div>
                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let file of callFlowDetails.files">
                            <td>
                                <div class="row_container break-word">
                                    <div class="title_container col-md-4">
                                        <div class="row_title">File Name</div>
                                        <div class="row_detail">
                                            <a class="color-red cursorPointer" (click)="previewFiles(file)">
                                                {{ file['displayName'] }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="title_container col-md-3">
                                        <div class="row_title">File Type</div>
                                        <div class="row_detail">
                                            <b>{{ file?.fileType }}</b>
                                        </div>
                                    </div>
                                    <div class="title_container col-md-4">
                                        <div class="row_title">Created On</div>
                                        <div class="row_detail">
                                            <b>{{ file.createdOn }}</b>
                                        </div>
                                    </div>
                                    <div class="title_container col-md-1">
                                        <div class="row_title">Action</div>
                                        <div class="row_detail">
                                            <button
                                                class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                                                title="Download File"
                                                (click)="downloadFile(file)"
                                            >
                                                <i class="fa fa-download"></i>
                                            </button>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
